module.exports = __webpack_public_path__ + "static/media/logo.3fb614a9.png";